
export enum SurfboardPaymentResultEnum {
  INITIATED = 'PAYMENT_INITIATED',
  PROCESSED = 'PAYMENT_PROCESSED',
  COMPLETED = 'PAYMENT_COMPLETED',
  FAILED = 'PAYMENT_FAILED',
  CANCELED = 'PAYMENT_CANCELLED',
}